import isEqual from "lodash.isequal"
import React, { useState } from "react"
import { SelectPill } from "@/components/select-pill/select-pill.tsx"
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/shadcn/dialog"
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
  NestedDrawer,
} from "@/components/shadcn/drawer.tsx"
import { formatAgeRange, type AnimalLifeSpan } from "@/features/farm"
import AnimalAgeDrawerFilter from "@/features/farm/components/animal-age-drawer-filter/animal-age-drawer-filter.tsx"
import { FILTER_AGE } from "@/features/farm/types/animal-ages-constants.ts"
import { useMediaQuery } from "@/hooks/use-media-query"

interface Props {
  selectedAge: AnimalLifeSpan
  onAgeSelection: (ageSelection: AnimalLifeSpan) => void
  isNested?: boolean
}

const AnimalAgeDrawer: React.FC<Props> = ({
  selectedAge,
  onAgeSelection,
  isNested = false,
}) => {
  const [open, setOpen] = useState<boolean>(false)
  const isDesktop = useMediaQuery("(min-width: 768px)")
  const isSelected = !isEqual(selectedAge, FILTER_AGE)
  const ageStringified = formatAgeRange(selectedAge)

  const handleAgeSelection = (ageSelection: AnimalLifeSpan) => {
    setOpen(false)
    onAgeSelection(ageSelection)
  }

  const trigger = (
    <SelectPill isActive={isSelected}>{ageStringified}</SelectPill>
  )

  const content = (
    <AnimalAgeDrawerFilter
      currentValue={selectedAge}
      onValueChange={handleAgeSelection}
    />
  )

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>{trigger}</DialogTrigger>
        <DialogContent className="overflow-hidden">{content}</DialogContent>
      </Dialog>
    )
  }

  const DrawerComponent = isNested ? NestedDrawer : Drawer

  return (
    <DrawerComponent open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>{trigger}</DrawerTrigger>
      <DrawerContent style={{ height: "75dvh" }}>{content}</DrawerContent>
    </DrawerComponent>
  )
}

export default AnimalAgeDrawer
